// Toggle Hamburger
export const TOGGLE_HAMBURGER = 'hamburger::toggle'
export const CLOSE_HAMBURGER = 'hamburger::close'
